import { render, staticRenderFns } from "./xypay.vue?vue&type=template&id=ac092114&scoped=true&"
import script from "./xypay.vue?vue&type=script&lang=js&"
export * from "./xypay.vue?vue&type=script&lang=js&"
import style0 from "./xypay.vue?vue&type=style&index=0&id=ac092114&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac092114",
  null
  
)

export default component.exports